<template>
  <v-card outlined class="pa-5 mb-5">
    <p>{{ name }}</p>
    <v-radio-group
      v-for="el in items"
      v-model="localData"
      :readonly="readonly"
      :disabled="disabled"
    >
      <v-radio class="elevation-0" :label="el.name" :value="el.id"></v-radio>
    </v-radio-group>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Select',

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localData: null
  }),

  computed: {},

  watch: {
    localData: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.localData)) {
          return;
        }
        this.setData();
      }
    }
  },

  created() {},

  methods: {
    setData() {
      this.localData = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', this.localData);
    }
  }
};
</script>
